// category module types
export const LayoutMap = {
  GET_TOGGLE_STATE: "GET_TOGGLE_STATE",
  GET_NOTIFICATION: "GET_NOTIFICATION",
  ADDRESS_REQUEST: "ADDRESS_REQUEST",
  ADDRESS_SUCCESS: "ADDRESS_SUCCESS",
  ADDRESS_FAIL: "ADDRESS_FAIL"
};
